import React, { useState, useEffect } from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';
import { MDBContainer, MDBBtn as MDBTN, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { useLanguage } from '../../../context/language';
import { sendEmail } from '../../../api/fastcoinService';
import { getStrLang } from '../../Translate';
import { requestBilletPF, requestBilletPJ } from '../../../api/fastcoinService';
import moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import Copy from '../../../assets/copy.svg';
import Loading from '../../../assets/loading.gif';
import $ from 'jquery';
import { getAceiteTermos } from '../../../api/fastcoinService';


const Boleto = (props) => {
    //calling the variables
    const { translate, lang, orderFromDeposit } = useLanguage();

    //Hooks
    const [modal, setModal] = useState(false); //define if the modal is open or close
    const [modal1, setModal1] = useState(false); //define if the modal is open or close
    const [loading, setLoading] = useState(false); //define loading the api to generate the boletos
    const [email, setEmail] = useState(sessionStorage.getItem("email") || ""); //store the users email
    const [mensagem, setMensagem] = useState({
        msg1: "",
        msg2: "",
        msg3: "",
        msg4: ""
    }); //messages of the request boleto screen 

    //getting parameters from URL /deposit
    let orderNumber = sessionStorage.getItem("order_no");
    let broker = sessionStorage.getItem("broker");

    //validate if the terms have been accepted
    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    //console.log(res);
                    if (res !== undefined) {
                        sessionStorage.setItem("showTermos_deposit", false);
                        props.setShowTermos(false);
                        translate();
                    } else {
                        sessionStorage.setItem("showTermos_deposit", true);
                        props.setShowTermos(true);
                    }
                })
                .catch(err => {
                    if (err.error.includes("Could not find the term")) {
                        sessionStorage.setItem("showTermos_deposit", true);
                        props.setShowTermos(true);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }
    }, []);

    //translates 
    useEffect(() => {
        translate();
    }, [translate]);

    //change the modal to the loading api
    const toggle = () => {
        setModal(!modal)
        setLoading(false);
    }
    const toggle1 = () => {
        setModal1(!modal1)
        setLoading(false);
    }

    //call the send email to get a boleto option
    const handleEmail = (event) => {
        const { value } = event.target;
        setEmail(value);
        sessionStorage.setItem("email", value);
    }

    //call if the boleto amount is more than 10k, thats the limit of gerenciaet bank for each boleto
    function callSendEmailError(email, phone, error) {
        let objData = {};
        objData.to = "boletos@payeasy.tech";
        objData.subject = "BOLETO - FALHA";
        objData.text = `<b>Uma nova tentativa de solicitação de boleto!</b><br/><b>Origem: </b>${broker}<br/><b>Ordem: </b>${orderNumber}<br/><b>Valor: </b>${sessionStorage.getItem("conv_amount")}<br/><b>Nome Cliente: </b>${sessionStorage.getItem("full_Name")}<br/><b>Email: </b>${email}<br/><b>CPF/CNPJ: </b>${sessionStorage.getItem("documento_cliente")}<br/><b>Contato: </b>${phone}<br/><b>Erro: </b>${error}`;
        sendEmail(objData);
    }

    //calling to inform a boleto was sucessfull generated
    function callSendEmail(email, phone) {
        let objData = {};
        objData.to = "boletos@payeasy.tech";
        objData.subject = " BOLETO";
        objData.text = `<b>Uma nova solicitação de boleto!</b><br/><b>Origem: </b>${broker}<br/><b>Ordem: </b>${orderNumber}<br/><b>Valor: </b>${sessionStorage.getItem("conv_amount")}<br/><b>Nome Cliente: </b>${sessionStorage.getItem("full_Name")}<br/><b>Email: </b>${email}<br/><b>CPF/CNPJ: </b>${sessionStorage.getItem("documento_cliente")}<br/><b>Contato: </b>${phone}`;
        sendEmail(objData);
        setMensagem({
            msg1: getStrLang(lang.nameLang, "msg1"),
            msg2: getStrLang(lang.nameLang, "msg2"),
            msg3: email,
            msg4: getStrLang(lang.nameLang, "msg2_span")
        });
    }
    function doEffect() {
        let ctrl = $("#message-crypto span");
        $(ctrl).css("display", "flex");
        $(ctrl).fadeIn(500, function () {
            ctrl.effect("pulsate", 15000).fadeOut(500);
            doEffect(ctrl);
        });
    }
    useEffect(()=>{
        if(loading){
            doEffect()
        }
    },[loading])

    //call the function to generate the boleto to gerenecianet bank
    async function generateTicket() {
        //console.log('inicia a geração do boleto');
        sessionStorage.removeItem("infoBillet");
        setLoading(true);
        //Preparando valores para requisição
        if (sessionStorage.getItem("documento_cliente") !== null) {
            let docCli = sessionStorage.getItem("documento_cliente").replace(new RegExp("[^\\d]", 'g'), '');
            //let phone = document.getElementById("input_phone").value.replace(new RegExp("[^\\d]", 'g'), '');
            let phone = "8133224455";
            let email = document.getElementById("input_email").value;
            sessionStorage.setItem("email", email);
            let amount = sessionStorage.getItem("conv_amount").replace(new RegExp("[^\\d|,]", 'g'), '');
            amount = amount.replace(',', '.');
            let tomorrow = moment()
                //.add(0, 'days')
                .format('YYYY-MM-DD');

            //validate telefone number
            //if (new RegExp("^[1-9]{2}9?[0-9]{8}$", 'g').test(phone)) {
            //Validate e-mail
            if (new RegExp("\\w+@\\w+", 'g').test(email)) {
                //Validate order amount
                if (parseInt(amount) < 1000000) {
                    //define if will call for person or company to generate the boleto
                    if (docCli.length > 11) {
                        await requestBilletPJ(docCli, amount, sessionStorage.getItem("full_Name"), phone, orderNumber, tomorrow, email)
                            .then(res => {
                                if (res.data) {
                                    sessionStorage.setItem("infoBillet", res.data);
                                    sessionStorage.setItem("barcode", res.data.barcode);
                                    sessionStorage.setItem("link_boleto", res.data.link);
                                    setLoading(false);
                                    callSendEmail(email, phone);
                                    $(translate());
                                }                              
                            })
                            .catch(err => {
                                setLoading(false);
                                sessionStorage.removeItem("infoBillet");
                                callSendEmailError(email, phone, err.error_description || err.message);
                                setMensagem({
                                    msg1: getStrLang(lang.nameLang, "msg3"),
                                    msg2: getStrLang(lang.nameLang, "error_boleto"),
                                    msg3: err.error_description || err.message,
                                    msg4: getStrLang(lang.nameLang, "error_boleto2")
                                });
                                toggle();
                                $(translate());
                            })
                    } else {
                        await requestBilletPF(docCli, amount, sessionStorage.getItem("full_Name"), phone, orderNumber, tomorrow, email)
                            .then(res => {
                                if (res.data) {
                                    sessionStorage.setItem("infoBillet", res.data);
                                    sessionStorage.setItem("barcode", res.data.barcode);
                                    sessionStorage.setItem("link_boleto", res.data.link);
                                    setLoading(false);
                                    callSendEmail(email, phone);
                                    $(translate());
                                }
                                else if (res.redirect_url) {
                                    sessionStorage.setItem("billet_redirect", res.redirect_url);
                                    sessionStorage.setItem("infoBillet", "frame");
                                    sessionStorage.setItem("barcode", "frame");
                                    sessionStorage.setItem("link_boleto", "frame");
                                    //setLoading(false);
                                    callSendEmail(email, phone);
                                    toggle1();
                                }
                            })
                            .catch(err => {
                                setLoading(false);
                                sessionStorage.removeItem("infoBillet");
                                sessionStorage.removeItem("billet_redirect");
                                callSendEmailError(email, phone, err.error_description || err.message);
                                setMensagem({
                                    msg1: getStrLang(lang.nameLang, "msg3"),
                                    msg2: getStrLang(lang.nameLang, "error_boleto"),
                                    msg3: err.error_description || err.message,
                                    msg4: getStrLang(lang.nameLang, "error_boleto2")
                                });
                                toggle();
                                $(translate());
                            })
                    }
                } else {
                    callSendEmailError(email, phone, "Valor do boleto superior a R$10.000");
                    setMensagem({
                        msg1: "",
                        msg2: "",
                        msg3: <center>{getStrLang(lang.nameLang, "error_boleto_retorno")}<br />{getStrLang(lang.nameLang, "error_boleto_retorno2")}</center>,
                        msg4: ""
                    });
                    toggle();
                    $(translate());
                }
            } else {
                setMensagem({
                    msg1: getStrLang(lang.nameLang, "msg3"),
                    msg2: "",
                    msg3: getStrLang(lang.nameLang, "msg4"),
                    msg4: ""
                });
                toggle();
                $(translate());
            }
            /*
            } else {
                console.log('erro telefone');
                setMensagem({
                    msg1: getStrLang(lang.nameLang, "msg3"),
                    msg2: "",
                    msg3: getStrLang(lang.nameLang, "msg6_phone"),
                    msg4: ""
                });
                toggle();
                $(translate());
            }
            */
        } else {
            alert("Documento do cliente não encontrado - Atualize a página!");
        }

    }

    //show toast that it was copied
    const notify = () => {
        navigator.clipboard.writeText(sessionStorage.getItem("barcode"));
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }

    //show the bar code numbers after generated 
    //give a option to view the boleto in a new tab
    const infoReturnBillet = () => {
        return (           
                <div className="content-boleto col-content-boleto">
                    <div className="form-group">
                        <div>
                            <label htmlFor="codebar" data-lang-str="CODEBAR" className="bold_text_ted"></label>
                            <div className="input-line">
                                <input type="text" id="codebar" className="form-control form-control-lg" value={sessionStorage.getItem("barcode")} disabled="true" />
                                <div className="copy-area" onClick={() => notify()}>
                                    <img src={Copy} alt="Copy" />
                                    <Toaster
                                        toastOptions={{
                                            className: '',
                                            style: {
                                                border: '1px solid #0d4fb8',
                                                color: '#0d4fb8',
                                                padding: '12px',
                                                top: '300px',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <MDBBtn data-lang-str="btn_visualizar_boleto" href={sessionStorage.getItem("link_boleto")} target="_blank"></MDBBtn>
                </div> 
        )
    }

    //fields for the user for the boleto
    const fieldsRequestBillet = () => {
        return (
            <>
                {loading && <div className="infoarea-pix">
                    <div id='message-crypto' className='infoarea-crypto-message text-center'>
                        <span>{getStrLang(lang.nameLang, "waiting-payment-boleto")}</span>
                    </div>
                </div>}
                <div className="content-boleto col-content-boleto">
                    <div className="form-group row-ticket">
                        <div>
                            <label htmlFor="formGroupExampleInput" data-lang-str="input_name"></label>
                            <input
                                type="text"
                                className="form-control"
                                id="input_name"
                                value={sessionStorage.getItem("full_Name")}
                                disabled={true}
                                readOnly={true}
                            />
                        </div>
                        <div style={{ display: "none" }}>
                            <label htmlFor="formGroupExampleInput" data-lang-str="input_phone"></label>
                            <input
                                type="text"
                                className="form-control"
                                id="input_phone"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="formGroupExampleInput" data-lang-str="enter_email"></label>
                        <input
                            type="text"
                            className="form-control"
                            id="input_email"
                            value={email}
                            onChange={handleEmail}
                        />
                    </div>
                    <MDBBtn onClick={() => { generateTicket() }}>{loading ? <img src={Loading} alt={"loading"} width="20px" height="20px" /> : getStrLang(lang.nameLang, "btn_confirmEmail")}</MDBBtn>
                </div>
            </>

        )
    }
    return (
        <div>
            <div className="form-boleto-header">
                {/*<img id="image-logo-tabs" src={Logo} alt={"Logo"}/>*/}
            </div>
            {sessionStorage.getItem("infoBillet") !== null ? infoReturnBillet() : fieldsRequestBillet()}
            {/*O código abaixo é uma mensagem de boleto indisponível - Para quando o time da Fastcoin quiser desabilitar a função*/}
            {/*<h4 className="div-info-pag" data-lang-str="inf_boleto"></h4>*/}
            {modal &&
                <MDBContainer>
                    <MDBModal isOpen={modal} toggle={toggle}>
                        <MDBModalHeader toggle={toggle}>{mensagem.msg1}</MDBModalHeader>
                        <MDBModalBody>
                            <p>{mensagem.msg2}<br />{mensagem.msg3}</p><br />
                            <p>{mensagem.msg4}</p>
                        </MDBModalBody>
                    </MDBModal>
                </MDBContainer>
            }
        </div>
    )
}

export default Boleto;